import { isObjectLike } from 'lodash';

import { mapTreeSelectIds } from 'utils';

import { AggregatedProductIdentity, AggregatedProductIdentityCreate, AggregatedProductIdentityUpdate, ProductIdentityValue } from 'codegen';
import { TRequestCallback } from 'types';

export const getFormattedProductIdentities = (identity: AggregatedProductIdentity & { id: number }) => ({
  ...identity,
  retailers: identity.retailers.map((merchant) => ({
    ...merchant,
    label: merchant.name,
    value: `${merchant.id}-${merchant.companyId}`,
  })),
});

export const handlePatchIdentity = (
  patchIdentities: TRequestCallback<AggregatedProductIdentityUpdate>,
  identities: (AggregatedProductIdentity & { id: number })[],
) => ({
  id,
  retailers: ret,
  ...rest
}: AggregatedProductIdentity & { id: number }) => {
  const retailers = ret.some(isObjectLike)
    ? ret.map((merchant) => ({ id: mapTreeSelectIds(merchant.id) }))
    : ret.map((ID) => ({ id: mapTreeSelectIds(String(ID)) }));

  const values = identities.find((identity) => identity.id === id)?.values as ProductIdentityValue[];

  const payload = {
    ...rest,
    values,
    retailers,
  };

  patchIdentities({ payload });
};

export const handlePostIdentity = (
  postIdentities: TRequestCallback<AggregatedProductIdentityCreate>,
) => ({
  id,
  values,
  retailers,
  ...rest
}: AggregatedProductIdentity & { id: number }) => {
  const payload = {
    ...rest,
    values: [{ value: values.toString(), isActive: true }],
    retailers: retailers?.map((ID) => ({ id: mapTreeSelectIds(ID as unknown as string) })),
  };

  postIdentities({ payload });
};
